import React from 'react'
import { useState, useRef, useEffect, useSelector, useDispatch } from 'hooks'
import { ReCAPTCHA, Button, Select, Input, TextArea, T, SpinningCircle } from 'components'
import { REGISTRIES } from 'common/constants'
import { submitHelpForm, fetchRegistry } from 'store/actions'
import { StyledContactForm } from './StyledHelp'

const languages = [
  { value: 1, text: 'English' },
  { value: 7, text: 'Français' },
  { value: 9, text: 'Deutsch' },
  { value: 2, text: 'Italiano' },
  { value: 32, text: 'Norsk' },
  { value: 4, text: 'Português ' }, // like this in db - should be fixed
  { value: 11, text: 'Русский' },
  { value: 3, text: 'Español' },
  { value: 8, text: 'Svenska' },
]

const defaultValues = {
  problemDescription: '',
  languageId: '1',
  reasonId: '101',
}

const FormItem = ({ name, label, className, children }) => (
  <div className={`form-item${className ? ' ' + className : ''}`}>
    <T as="label" htmlFor={name} className="info-area" label={`support/${label}`} />
    <div className="input-area">{children}</div>
  </div>
)

const SubmitButton = props => <Button type="submit" className="submit" label="support/submit" {...props} />

const useCaptcha = () => {
  const [securityCode, setSecurityCode] = useState(null)
  const ref = useRef(null)
  const resetCaptcha = () => {
    setSecurityCode(null)
    ref?.current.reset()
  }
  const Captcha = <ReCAPTCHA ref={ref} sitekey="6LcYSSsUAAAAAPY2VqBtN-An2LJmXO_UHTqT6yQ9" onChange={setSecurityCode} />
  return { securityCode, resetCaptcha, Captcha }
}

const ContactForm = () => {
  const { loading: submitting } = useSelector(s => s.account.helpForm)
  const { securityCode, resetCaptcha, Captcha } = useCaptcha()
  const me = useSelector(s => s.myProfile)
  const guest = !!me.error
  const [fields, setFields] = useState({ ...defaultValues, email: me.email || '', screenname: me.screenName || '' })
  const dispatch = useDispatch()

  useEffect(() => {
    guest && dispatch(fetchRegistry([REGISTRIES.FEEDBACK_REASON]))

    resetCaptcha()
  }, [])

  const onChange = ({ target: { name, value } }) => setFields({ ...fields, [name]: value })

  const onSubmit = e => {
    e.preventDefault()

    dispatch(submitHelpForm({ ...fields, securityCode }))
    setFields({ ...fields, ...defaultValues })

    resetCaptcha()
  }

  return (
    <StyledContactForm className="form" onChange={onChange} onSubmit={onSubmit}>
      <FormItem name="screenname" label="supportName" className={guest ? '' : 'hidden'}>
        <Input name="screenname" type="text" value={fields.screenname} required />
      </FormItem>
      <FormItem name="email" label="supportMail" className={guest ? '' : 'hidden'}>
        <Input id="email" type="email" name="email" value={fields.email} required />
      </FormItem>

      <FormItem name="languageId" label="supportLanguage">
        <Select name="languageId" selected={fields.languageId} options={languages} />
      </FormItem>
      <FormItem name="reasonId" label="supportCat">
        <Select name="reasonId" selected={fields.reasonId} options={useSelector(s => s.registry.feedbackReasons)} />
      </FormItem>
      <FormItem name="problemDescription" label="describeRequest" className="textarea-item">
        <TextArea
          id="problemDescription"
          name="problemDescription"
          cols="30"
          rows="10"
          value={fields.problemDescription}
          required
        />
      </FormItem>
      <div className="form-item captcha-item">{Captcha}</div>
      <div className="form-item submit-item">
        {submitting ? <SpinningCircle /> : <SubmitButton disabled={!securityCode} />}
      </div>
    </StyledContactForm>
  )
}

export default ContactForm
